import React, {Fragment, useEffect, useRef, useState} from "react";
import {Link, NavLink, useLocation, useParams} from "react-router-dom";
import '../../assets/cssnew/Products.css';
import axios from "axios";
import clientconfigwebapp, {
    Agent_by_user_get_appbk,
    check_login_appbk, empty_bk,
    FormatNumberByhkh,
    get_first_last_name_local, modal_select_agent_show_hide,
    scrollTo_uphk, seo_setmetabk, Token_get_appbk
} from "../../clientconfigwebapp";
import {toast, ToastContainer} from "react-toastify";
import Grid from '@mui/material/Grid';

import Master_Front from "../../pages/Master_Front";
import LazyLoad from 'react-lazy-load';
import {Skeleton} from "@mui/material";


import ProductCard from "../../components/Card_boxs/ProductCard";
import {Icon_Sort1} from "../../assets/icones/icones";

import baner_3new from "../../assets/images/baner-3new.jpg"
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ReactFullPageLoadinghk from "../../components/layaout/LoadingFullpagehk";

function useQuery() {
    /////توجه اینجا نباید تغییر بدی همیشه باید سرچ باشه حتی پارامتر های دیگه هم باشه این تیکه کد تغییر نکند
    const {search} = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Products = (props) => {
    const location_get_urlbk = useLocation();

    const location = useLocation();
    const fullPath = location.pathname;

    // پردازش مسیر برای استخراج بخش‌های مختلف
    /// const id_cat_getuser = fullPath.split('/').filter(part => part); // حذف اسلش‌های خالی
    const id_cat_getuser = fullPath;

    console.log("Full Path:", fullPath);
    console.log("Path Parts:", id_cat_getuser);


    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile, setData_first_name_profile] = useState('');
    const [last_name_profile, setData_last_name_profile] = useState('');
    const [description_cat, setData_description_cat] = useState('');
    /*  end profile */


    let query = useQuery();

    ///const currentSort = query.get('sort');
    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");

    const [data_category_box, set_data_category_box] = useState([]);

    const [data_sub_category_box, set_data_sub_category_box] = useState([]);

    const [data_list_posts, set_list_post_Data] = useState([]);
    const [data_list_posts_pinned, set_list_posts_pinned_Data] = useState([]);
    const [data_paged_info, set_data_paged_info] = useState([]);


    const [activeSection, setActiveSection] = useState('sec-1');

    const [scrollY, setScrollY] = useState(0);


    /* paged start */
    let page_number = query.get("page");
    const page = useRef();

    function paginationStyle(e) {
        const list = page.current.childNodes;
        for (let index = 0; index < list.length; index++) {
            const element = list[index];
            element.className = "";
        }
        e.target.className = "active-page"
    }

    /* paged end */
    function logit() {
        setScrollY(window.pageYOffset);
    }


    const [isEnabled, setIsEnabled] = useState(false);

    const toggleSwitch = () => {
        setIsEnabled(!isEnabled);
        Load_api_page('filter')
    };


    const [isEnabled_Special_seller, setIsEnabled_Special_seller] = useState(false);

    const toggleSwitch_Special_seller = () => {
        setIsEnabled_Special_seller(!isEnabled_Special_seller);
        Load_api_page('filter')
    };


    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [filteredCities, setFilteredCities] = useState([]);
    const [selectedProvince, setSelectedProvince] = useState('');
    const [selectedCity, setSelectedCity] = useState('');


    useEffect(() => {
        if (selectedProvince) {
            setFilteredCities(cities.filter(city => city.provinceId === selectedProvince));
        } else {
            setFilteredCities([]);
        }
    }, [selectedProvince, cities]);


    const [selected_sort, setSelected_sort] = useState('new');


    useEffect(() => {

        scrollTo_uphk();
        Load_api_page('first');


    }, [location_get_urlbk]);


    const handleLinkClick = (section) => {
        setActiveSection(section);
        scrollToSection2(section);
    };

    const scrollToSection2 = (section) => {
        const element = document.getElementById(section);
    };


    const handler_Province = (value_get) => {
        setSelectedProvince(value_get);


        Load_api_page('filter')
    }

    const handler_City = (value_get) => {
        setSelectedCity(value_get);
        Load_api_page('filter')
    }

    const handler_Sort = (value_get) => {
        setSelected_sort(value_get);
        Load_api_page('filter')
    }


    const scrollToSection = () => {
        const element = document.getElementById("products-section");
        if (element) {
            const offset = 130; // مقدار آفست
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth" // انیمیشن اسکرول
            });
        }
    };

    const Load_api_page = (type_load = 'first') => {


        var config = null;

        if (check_login_appbk() == true) {
            config = {
                headers: {Authorization: `Bearer ${Token_get_appbk()}`}
            };
        }


        var post_get_user = "";
        if (!empty_bk(id_cat_getuser)) {
            post_get_user = String(id_cat_getuser);
        }


        /////console.log(post_get_user,"id_cat_getuser")
        ///console.log(page_number,"page_number");
        let search_text = "";

        if (!empty_bk(query.get("search"))) {
            search_text = String(query.get("search"));
        }


        var state_filter_get = document.getElementById("state_filter").value;
        var city_filter_get = document.getElementById("city_filter").value;
        var sort_filter_get = document.getElementById("sort_filter").value;

        let authentication_filter = "no"
        if (isEnabled == true) {
            authentication_filter = "yes";
        }

        let status_special_seller_filter = "no"
        if (isEnabled_Special_seller == true) {
            status_special_seller_filter = "yes";
        }

        const data_form = {
            post_slug: String(post_get_user),
            page_number: page_number,
            search: search_text,
            sort_get: String(sort_filter_get),
            state_filter: String(state_filter_get),
            city_filter: String(city_filter_get),
            authentication_filter: String(authentication_filter),
            status_special_seller_filter: String(status_special_seller_filter),
            type_load: String(type_load),

        };



        if (type_load == "filter") {
            Setloadinghkfullshow("true");
        }




        axios.post(`${clientconfigwebapp.siteurl}api/v1/posts-cat-products`, data_form, config)
            .then((res) => {
                Setloadinghkfullshow("false");

                ///console.log(res.data.data_paged_info,"data_paged_infodata_paged_info");
                /////  console.log(res.data)

                if (String(res.data).length > 0) {

                    set_list_post_Data([]);

                    if (String(res.data.wallet_inventory).length > 0) {
                        setData_wallet_balance(res.data.wallet_inventory);
                    }
                    if (!empty_bk(res.data.first_name_profile)) {
                        setData_first_name_profile(res.data.first_name_profile);
                        localStorage.setItem('first_name_Get', res.data.first_name_profile);
                    }
                    if (!empty_bk(res.data.last_name_profile)) {
                        setData_last_name_profile(res.data.last_name_profile);
                        localStorage.setItem('last_name_Get', res.data.last_name_profile);
                    }


                    if (String(res.data.posts).length > 0) {
                        set_list_post_Data(res.data.posts);
                    } else {
                        set_list_post_Data([]);
                    }


                    if (String(res.data.posts_pinned).length > 0) {
                        set_list_posts_pinned_Data(res.data.posts_pinned);
                    } else {
                        set_list_posts_pinned_Data([]);
                    }

                    if (String(res.data.data[0]).length > 0) {
                        set_data_paged_info(res.data.data[0]);
                    } else {
                        set_data_paged_info([]);
                    }






                    const dataItem = res?.data?.data?.[0];

                    if (dataItem) {
                        const title = (typeof dataItem.meta_title_seo === 'string' && dataItem.meta_title_seo.trim().length > 0)
                            ? dataItem.meta_title_seo
                            : dataItem.title_cat;

                        const metaDescription = (typeof dataItem.meta_descr_seo === 'string' && dataItem.meta_descr_seo.trim().length > 0)
                            ? dataItem.meta_descr_seo
                            : dataItem.title_cat;

                        seo_setmetabk({
                            title,
                            metaDescription,
                        });
                    }



                    if (type_load == "first") {


                        if (String(res.data.data_category_box).length > 0) {
                            set_data_category_box(res.data.data_category_box);
                        }
                        if (String(res.data.subcategories).length > 0) {
                            set_data_sub_category_box(res.data.subcategories);
                        }


                        setProvinces(res.data.list_provinces);
                        setCities(res.data.list_cities);
                    }

                    if(type_load=="filter"){  scrollToSection(); }






                } else {
                    if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }

            }).catch((err) => {
            Setloadinghkfullshow("false");
            toast.error('خطای اتصال به سرور کد 5156', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        });


    }


    return (
        <Fragment>

            <Master_Front wallet_balance={wallet_balance} first_name_profile={first_name_profile}
                          last_name_profile={last_name_profile}>


                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}/>

                <ToastContainer/>


                <div className={"box-cat-top-front container_bk_fronts"}>
                    {
                        data_paged_info && data_paged_info.title_cat && <h1 className={"text-[21px] text-center pb-[5px] font-bold font-['iran']"}>{data_paged_info.title_cat}</h1>
                    }
                    <div className={"text-center content-center justify-center"} style={{"display": "flex", "marginBottom": "5px"}}>
                        <Link className={"text-[13px]"} to={"/"}>صفحه اصلی</Link> / <span className={"pr-[10px] text-[13px]"} style={{"color": "#969fa2"}}> محصولات </span>
                    </div>




                    <div className={"boxbk_cat_home"} style={{display: "block"}}>

                        <div className="box_scroll_horizontal">

                            {

                                data_sub_category_box.length == 0 ? (
                                    <React.Fragment>

                                        <Skeleton variant="rectangular"
                                                  style={{width: "100%", height: "180px", borderRadius: "10px"}}/>

                                    </React.Fragment>


                                ) : (


                                    data_sub_category_box.map((item_post, index) => {

                                        return (

                                            <div className="item_cat_boxbk">
                                                {
                                                    <NavLink reloadDocument={true}
                                                             to={"/product-category/" + String(item_post.slug)}
                                                             className={"btn-cat-image-top"}>
                                                        <LazyLoad threshold={0.95}>
                                                            <img className="image-cat-boxbk" src={item_post.image_src}
                                                                 alt={item_post.name}/>
                                                        </LazyLoad>
                                                        <span className={"title-cat-boxbk"}>{item_post.name}</span>
                                                    </NavLink>

                                                }
                                                <span></span>

                                            </div>

                                        );

                                    })

                                )
                            }

                        </div>

                    </div>


                </div>


                <div
                    className={"box-border bg-[rgb(255,_255,_255)] rounded-[16px] relative bottom-[56px] w-full py-[15px] px-[15px] flex [flex-flow:row] justify-start items-center"}
                    style={{"border": "1px solid rgb(204, 204, 204)"}}>


                    <div className="flex flex-wrap  w-full justify-center">

                        <div className="w-full lg:w-2/12 px-2 mt-2">
                            <label htmlFor="state_filter" className="text-[14px] mb-[6px] block">
                                استان
                            </label>
                            <select
                                id="state_filter"
                                name="state_filter"
                                value={String(selectedProvince)}
                                onChange={(e) => handler_Province(e.target.value)}
                                className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-[13px]"
                            >
                                <option value="" className="font-iran text-[12px]">
                                    همه استان ها
                                </option>
                                { provinces &&
                                    provinces.map((item_post) => (
                                        <option key={item_post.provinceId} value={String(item_post.provinceId)}
                                                className="font-iran text-[12px]">
                                            {item_post.provinceName}
                                        </option>
                                    ))}
                            </select>
                        </div>

                        <div className="w-full lg:w-2/12 px-2 mt-2">
                            <label htmlFor="city_filter" className="text-[14px] mb-[6px] block">
                                شهرستان
                            </label>
                            <select
                                id="city_filter"
                                name="city_filter"
                                value={selectedCity}
                                onChange={(e) => handler_City(e.target.value)}
                                className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-[13px]"
                            >
                                <option value="" className="font-iran text-[12px]">
                                    همه شهرستان ها
                                </option>
                                {filteredCities &&
                                    filteredCities.map((item_post) => (
                                        <option key={item_post.cityId} value={String(item_post.cityId)}
                                                className="font-iran text-[12px]">
                                            {item_post.cityName}
                                        </option>
                                    ))}
                            </select>
                        </div>


                        <div className="w-full lg:w-2/12 px-2 mt-2">
                            <label htmlFor="sort_filter" className="text-[14px] mb-[6px] block">
                                مرتب سازی
                            </label>
                            <select
                                id="sort_filter"
                                name="sort_get"
                                value={selected_sort}
                                onChange={(e) => handler_Sort(e.target.value)}
                                className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-[13px]"
                            >
                                <option value="new" className="font-iran text-[12px]">
                                    جدید ترین
                                </option>
                                <option value="old" className="font-iran text-[12px]">
                                    قدیمی ترین
                                </option>
                                <option value="cheap" className="font-iran text-[12px]">
                                    ارزان ترین
                                </option>
                                <option value="expensive" className="font-iran text-[12px]">
                                    گران ترین
                                </option>
                            </select>
                        </div>


                        <div
                            className="w-full lg:w-2/12 px-2  flex  justify-start lg:justify-center items-end gap-x-[9px] my-[16px] lg:my-[0px]">

                            <div className={"relative lg:-top-[8px]"}>
                                <span className={"text-[14px] pl-[6px]"}>احراز هویت شده</span>
                                <div
                                    className={`relative inline-flex items-center h-6 rounded-full w-11 cursor-pointer ${
                                        isEnabled ? "bg-blue-500" : "bg-gray-400"
                                    }`} style={{direction: "ltr"}}
                                    onClick={toggleSwitch}
                                >
                              <span
                                  className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform ${
                                      isEnabled ? "translate-x-5" : "translate-x-1"
                                  }`}
                              />
                                </div>
                            </div>
                        </div>

                        <div
                            className="w-full lg:w-2/12 px-2  flex  justify-start lg:justify-center items-end gap-x-[9px]">

                            <div className={"relative lg:-top-[8px]"}>

                                <span className={"text-[14px] pl-[6px]"}>فروشنده ویژه</span>
                                <div
                                    className={`relative inline-flex items-center h-6 rounded-full w-11 cursor-pointer ${
                                        isEnabled_Special_seller ? "bg-blue-500" : "bg-gray-400"
                                    }`} style={{direction: "ltr"}}
                                    onClick={toggleSwitch_Special_seller}
                                >
                              <span
                                  className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform ${
                                      isEnabled_Special_seller ? "translate-x-5" : "translate-x-1"
                                  }`}
                              />
                                </div>
                            </div>
                        </div>


                    </div>


                </div>




                {
                    data_list_posts_pinned && data_list_posts_pinned.length > 0 ? (
                        <Fragment>


                            <Grid container direction="row" spacing={2} style={{paddingTop: "14px"}}>
                                {


                                    data_list_posts_pinned.map((item_post, index) => {


                                        return (

                                            <Grid item lg={2.4} md={2.4} sm={6} xs={12}>
                                                <ProductCard link_to={"product/" + String(item_post.id_post)}
                                                             data_full_curent_item={item_post}/>
                                            </Grid>

                                        )

                                    })

                                }

                            </Grid>

                        </Fragment>

                    ) : (
                        <Fragment></Fragment>)

                }



                <Link to={"/panel/product-registration"} reloadDocument={true}
                      className={"flex mt-[48px] mb-[48px] w-full"}>
                    <img src={baner_3new} className={"w-full"} alt={"online shop new"}/>
                </Link>

                    {
                        data_list_posts && data_list_posts.length > 0 ? (
                            <Fragment>


                                <Grid id={"products-section"} container direction="row" spacing={2} style={{paddingTop: "14px"}}>
                                    {


                                        data_list_posts.map((item_post, index) => {


                                            return (

                                                <Grid item lg={2.4} md={2.4} sm={6} xs={12}>
                                                    <ProductCard link_to={"product/" + String(item_post.id_post)}
                                                                 data_full_curent_item={item_post}/>
                                                </Grid>

                                            )

                                        })

                                    }

                                </Grid>

                            </Fragment>

                        ) : (
                            <Fragment></Fragment>)

                    }










                {data_paged_info.description_cat && (

                    <div className={"product_cat_seobox summery_text_cat rounded-[10px] pr-[18px] bg-[#ffffff] pl-[18px] pt-[11px] pb-[10px]"} style={{"border":"solid 1px #cbcbcb"}}
                         dangerouslySetInnerHTML={{__html: data_paged_info.description_cat}}></div>
                )}


            </Master_Front>

        </Fragment>
    );
}

export default Products;